import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** A browser-style frame for real product UI. The product is always dark, on light and dark pages. */
export function ProductFrame({ url, children, className }: { url: string; children: ReactNode; className?: string }) {
  return (
    <div className={cn('dark overflow-hidden rounded-frame border border-border bg-card shadow-frame', className)}>
      <div className="flex h-9 items-center gap-2 border-b border-border bg-sidebar px-3.5" aria-hidden="true">
        <span className="size-2.5 rounded-full bg-border" />
        <span className="size-2.5 rounded-full bg-border" />
        <span className="size-2.5 rounded-full bg-border" />
        <span className="ml-3 truncate font-mono text-xs text-muted-foreground">{url}</span>
      </div>
      {children}
    </div>
  )
}
